/**
 * Organization context for managing organization state
 */
import { createContext } from 'react';
import {
  Organization,
  OrganizationMembership,
  PendingInvite,
} from '@src/v3/interfaces/organization';

export interface OrganizationContextProps {
  // Organization data
  hasMembership: boolean;
  membership: OrganizationMembership | null;
  organization: Organization | null;
  isLoading: boolean;
  error: string | null;

  // Pending invites
  hasPendingInvites: boolean;
  pendingInvites: PendingInvite[];

  // Actions
  fetchMyOrganization: () => Promise<void>;
  fetchPendingInvites: () => Promise<void>;
  // eslint-disable-next-line no-unused-vars
  acceptInvite(token: string): Promise<{ success: boolean; error?: string }>;
  // eslint-disable-next-line no-unused-vars
  rejectInvite(token: string): Promise<{ success: boolean; error?: string }>;
  refreshOrganization: () => Promise<void>;
}

const OrganizationContext = createContext<OrganizationContextProps>({
  hasMembership: false,
  membership: null,
  organization: null,
  isLoading: false,
  error: null,
  hasPendingInvites: false,
  pendingInvites: [],
  fetchMyOrganization: async () => {},
  fetchPendingInvites: async () => {},
  acceptInvite: async () => ({ success: false }),
  rejectInvite: async () => ({ success: false }),
  refreshOrganization: async () => {},
});

export default OrganizationContext;
